import styles from "./styles.module.scss";
import { CoachingToolsItemBase, CoachingToolsItemBaseProps } from "../ItemBase/CoachingToolsItemBase";
import { Clock2, Sparkles } from "lucide-react";
import { _ } from "i18n";

type Reviews = {
	sent: number;
	total: number;
};

export interface CoachingToolsReviewItemProps extends Omit<CoachingToolsItemBaseProps, "children" | "accent"> {
	name: string;
	teamReview?: Reviews;
	playerReviews?: Reviews;
}

export const CoachingToolsReviewItem = ({ name, teamReview, playerReviews, ...props }: CoachingToolsReviewItemProps) => {
	const noEligiblePlayers = playerReviews && playerReviews.total === 0;

	const buildSentReviewsText = () => {
		// No eligible players to review
		if (noEligiblePlayers) {
			return _("game.coachingTools.reviewItem.noEligiblePlayers");
		}

		if (teamReview && playerReviews) {
			return _("game.coachingTools.reviewItem.bothReviewsSent", {
				teamSent: teamReview.sent,
				teamTotal: teamReview.total,
				playerSent: playerReviews.sent,
				playerTotal: playerReviews.total,
			});
		}

		if (teamReview) {
			return _("game.coachingTools.reviewItem.teamOnlyReviewSent", { sent: teamReview.sent, total: teamReview.total });
		}

		if (playerReviews) {
			return _("game.coachingTools.reviewItem.playerOnlyReviewsSent", { sent: playerReviews.sent, total: playerReviews.total });
		}

		return "";
	};

	const sentReviewsText = buildSentReviewsText();

	return (
		<CoachingToolsItemBase {...props} accent>
			<div className={styles["review-item"]}>
				<div className={styles["review-item__header"]}>
					<p className={styles["review-item__name"]}>{name}</p>
					<div className={styles["review-item__tag"]}>
						<Sparkles className={styles["review-item__tag-icon"]} />
						<p className={styles["review-item__tag-text"]}>{_("game.coachingTools.reviewItem.aiTag")}</p>
					</div>
				</div>
				<p className={styles["review-item__description"]}>{_("game.coachingTools.reviewItem.description")}</p>
				{sentReviewsText !== "" && (
					<div className={styles["review-item__sent-reviews"]}>
						{!noEligiblePlayers && <Clock2 className={styles["review-item__sent-reviews-icon"]} />}
						<p className={styles["review-item__sent-reviews-text"]}>{sentReviewsText}</p>
					</div>
				)}
			</div>
		</CoachingToolsItemBase>
	);
};
